import { render } from "./CIS-Controls-Navigator-Listing-Safeguard.vue?vue&type=template&id=3c221d7f&scoped=true"
import script from "./CIS-Controls-Navigator-Listing-Safeguard.vue?vue&type=script&lang=js"
export * from "./CIS-Controls-Navigator-Listing-Safeguard.vue?vue&type=script&lang=js"

import "./CIS-Controls-Navigator-Listing-Safeguard.vue?vue&type=style&index=0&id=3c221d7f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c221d7f"]])

export default __exports__